<template lang="pug">
.filter
  form(@submit.prevent="onFilter")
    modal(:active="true", title="Filtros das notas", @close="close")
      .columns(slot="modal-body")
        .column.col-12.pb-1 Período
        .column.col-6
          datepicker(v-model="q.created_at_gteq", placeholder="De")
        .column.col-6
          datepicker(v-model="q.created_at_lteq", placeholder="Até")
        .column.col-6
          form-group(label="CPF/CNPJ do prestador")
            the-mask.form-input(
              v-model="q.prestador_cpf_cnpj_eq",
              :mask="['###.###.###-##', '##.###.###/####-##']"
            )
      .float-right(slot="modal-footer")
        a.btn.btn-link.btn-lg.text-gray(@click="clearFilter", v-if="filtered") Limpar filtros
        button.btn.btn-primary.btn-lg Filtrar
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter";
import Datepicker from "@/components/inputs/Datepicker";
import FormGroup from "@/components/helpers/FormGroup";

export default {
  components: { FormGroup, Datepicker },
  vuex: { notasRecebidas: defaultStoreImports },
  mixins: [filterMixin],
};
</script>
